import React from 'react';
import PropTypes from 'prop-types';

import i18n from '~shared/utils/i18n';
import { getFullUrl } from '~spa/Utils/VirtualSports';
import { rewriteUrl } from '~shared/utils/uriAliases';
import {
    VIRTUALS_LIVE_NOW,
    VIRTUAL,
    INSTANT,
    GTM_VIRTUAL_SPORT_LINK_BAR,
} from '~spa/Pages/VirtualSports/constants';
import './styles/virtual-sports-link-bar.scss';


const VirtualSportsLinkBar = ({
    virtualSport,
    ctaI18nKey=VIRTUALS_LIVE_NOW,
    isFooter,
    gtmMainComponent,
    gtmSecondaryComponentOverride='',
 }) => {
    const {
        game_name, game_slug,
    } = virtualSport;
    const eventUrl = rewriteUrl(getFullUrl(virtualSport));
    const normalizedSportSlug = game_slug.replace(INSTANT, VIRTUAL);
    const gtmSecondaryComponent = gtmSecondaryComponentOverride !== '' ? gtmSecondaryComponentOverride : GTM_VIRTUAL_SPORT_LINK_BAR;
    const gtmAttribute = `${gtmMainComponent};${gtmSecondaryComponent};${game_slug}`;

    return (
        <div className={`v-sports-link${isFooter ? ' v-sports-link--with-border' : ' v-sports-link--with-spacing'}`}>
            <a className={`v-sports-link__title v-sports-link__title--${normalizedSportSlug}`} href={eventUrl} data-spectate-product={gtmAttribute}>
                <span className="v-sports-link__sport">{isFooter ? game_name.toLocaleUpperCase() : game_name}</span>
                <span className="v-sports-link__live-now">{i18n.t(ctaI18nKey).toLocaleUpperCase()}</span>
            </a>
        </div>
    );
};

VirtualSportsLinkBar.propTypes = {
    virtualSport: PropTypes.shape({
        game_id: PropTypes.string.isRequired,
        game_name: PropTypes.string.isRequired,
        game_slug: PropTypes.string.isRequired,
        sport_id: PropTypes.number,
        tournament_id: PropTypes.number,
        event_id: PropTypes.number,
        l10n_game_slug: PropTypes.string,
    }).isRequired,
    ctaI18nKey: PropTypes.string,
    isFooter: PropTypes.bool,
    gtmMainComponent: PropTypes.string.isRequired,
    gtmSecondaryComponentOverride: PropTypes.string,
};

VirtualSportsLinkBar.defaultProps = {
    virtualSport: {
        sport_id: 0,
        tournament_id: 0,
        event_id: 0,
        l10n_game_slug: '',
    },
    ctaI18nKey: VIRTUALS_LIVE_NOW,
    isFooter: false,
    gtmSecondaryComponentOverride: '',
};

export default VirtualSportsLinkBar;
